/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';

const UnderConstructionPage = ({ pageTitle }) => {
  return (
    <div className="flex items-center justify-center min-h-[640px] px-4 py-4 bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <div className="relative max-w-xl w-full rounded-2xl border border-slate-200 bg-white shadow-[0_20px_40px_rgba(0,0,0,0.05)] p-10 text-center">
        {/* Icon */}
        <div className="mb-16 flex justify-center relative z-10">
          <div className="relative group">
            <div
              className="absolute -inset-10 rounded-full bg-gradient-to-r from-indigo-600/30 via-blue-500/30 to-cyan-400/30 blur-3xl opacity-80 
                    animate-[pulse_6s_ease-in-out_infinite] group-hover:opacity-100 transition-all duration-700"
            />

            <div className="absolute -inset-1 rounded-[2.7rem] bg-white/5 backdrop-blur-xl ring-1 ring-white/10" />

            <div
              className="relative h-36 w-36 rounded-[2.7rem] 
                    bg-gradient-to-br from-indigo-600 via-blue-600 to-cyan-500
                    flex items-center justify-center
                    shadow-[0_30px_80px_rgba(59,130,246,0.45)]
                    border border-white/20
                    transition-all duration-500
                    group-hover:scale-[1.03]"
            >
              <svg
                className="h-16 w-16 text-white drop-shadow-lg 
                   animate-[spin_14s_linear_infinite] 
                   group-hover:animate-[spin_6s_linear_infinite]"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.4}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 3v3m0 0a3 3 0 110 6m0-6a3 3 0 100 6
             m-7 9a3 3 0 100-6m0 6a3 3 0 100 6
             m0-6v3m0-9V3
             m7 9v12
             m7-3a3 3 0 100-6m0 6a3 3 0 100 6
             m0-6v3m0-9V3"
                />
              </svg>
            </div>

            <div
              className="absolute -top-6 -right-6 
                    animate-[float_4s_ease-in-out_infinite]"
            >
              <div
                className="flex items-center gap-2 rounded-full 
                      bg-gradient-to-r from-white/90 to-white/70
                      backdrop-blur-xl
                      px-4 py-2 text-xs font-semibold text-indigo-900
                      shadow-[0_10px_25px_rgba(0,0,0,0.15)]
                      ring-1 ring-white/60"
              >
                <span className="relative flex h-3 w-3">
                  <span
                    className="absolute inline-flex h-full w-full rounded-full 
                           bg-emerald-400 opacity-75 
                           animate-ping"
                  />
                  <span
                    className="relative inline-flex rounded-full h-3 w-3 
                           bg-emerald-500 border border-white"
                  />
                </span>

                <span className="tracking-wide uppercase">Processing</span>
              </div>
            </div>
          </div>
        </div>

        {/* Headline */}
        <h1 className="text-3xl font-semibold text-slate-900 mb-3 tracking-tight">
          This page isn’t ready yet
        </h1>

        <p className="text-slate-600 text-base leading-relaxed mb-10">
          We’re preparing this section for you. Once your repository has enough
          commit activity, this page will automatically become available.
        </p>

        {/* Info Card */}
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-5 mb-8 text-left">
          <div className="flex items-center gap-2 mb-2">
            <svg
              className="h-5 w-5 text-blue-600"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
            <p className="font-medium text-slate-800">Why am I seeing this?</p>
          </div>

          <p className="text-sm text-slate-600">
            This view requires commit data to generate meaningful insights. As
            soon as commits are detected, access will be unlocked automatically.
          </p>
        </div>

        {/* Page Name */}
        <div className="mb-8">
          <p className="text-xs uppercase tracking-widest text-slate-400 mb-1">
            Requested page
          </p>
          <p className="text-lg font-medium text-slate-900">{pageTitle}</p>
        </div>

        {/* Footer hint */}
        <div className="flex items-center justify-center gap-2 text-sm text-slate-600">
          <svg
            className="h-4 w-4 text-emerald-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          <span>
            You can still explore other features from the{' '}
            <Link
              to="/settings/plan-configuration"
              className="font-medium text-indigo-600 hover:text-indigo-500 transition-colors duration-200 underline decoration-2 underline-offset-2 hover:decoration-indigo-400"
            >
              Settings pages
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default UnderConstructionPage;
